import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SessionCacheModel } from '../models/session-cache.model';
import { BehaviorSubject } from 'rxjs';
import { runtimeEnv } from 'src/environments/env-loader';

@Injectable({
  providedIn: 'root'
})
export class SessionCacheService {
  readonly TO_MILISECOND = 1000 * runtimeEnv.THROTTLEDREFRESHBALANCE;

  private sessionDataSubject = new BehaviorSubject<string | null>(null);
  public sessionData$ = this.sessionDataSubject.asObservable();

  saveDataWithExpiration(key: string, values: SessionCacheModel) {
    sessionStorage.setItem(key, JSON.stringify(values));
  }

  getData(key: string) {
    return sessionStorage.getItem(key);
  }

  isDataExpired(key: string): boolean {
    let expiration = sessionStorage.getItem(key) ? JSON.parse(sessionStorage.getItem(key)).iat : null;
    return expiration < new Date().getTime() ? true : false;
  }

  expiredData(key) {
    this.isDataExpired(key) ? sessionStorage.removeItem(key) : null;
  }

  updateData() {
    this.sessionDataSubject.next('update');
  }

  deleteData(key: string) {
    sessionStorage.removeItem(key);
    this.sessionDataSubject.next(key);
  }
}
